'use client';
import React from 'react';

const HeroSection: React.FC = () => {
  const handleScrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center overflow-hidden"
      style={{ paddingTop: '80px' }}
      aria-label="Hero section"
    >
      {/* Background Image with Overlay */}
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1504711434969-e33886168f5c?w=1600&q=80')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
        role="img"
        aria-label="Professional magazine publishing workspace with editorial materials"
      />
      <div
        className="absolute inset-0 z-0"
        style={{
          background: 'linear-gradient(135deg, rgba(18,38,88,0.85) 0%, rgba(18,38,88,0.6) 50%, rgba(56,126,247,0.3) 100%)',
        }}
      />

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="max-w-2xl">
          {/* Eyebrow */}
          <div className="inline-flex items-center gap-2 mb-6">
            <div className="w-8 h-0.5" style={{ backgroundColor: '#387EF7' }} />
            <span
              className="text-sm uppercase tracking-widest font-medium"
              style={{ fontFamily: 'Poppins, sans-serif', color: '#387EF7', letterSpacing: '3px' }}
            >
              Jacksonville, FL
            </span>
          </div>

          {/* Headline */}
          <h1
            className="mb-6 leading-tight"
            style={{
              fontFamily: 'Roboto, sans-serif',
              fontWeight: 700,
              fontSize: 'clamp(36px, 5vw, 58px)',
              color: '#ffffff',
              lineHeight: 1.15,
            }}
          >
            <span style={{ color: '#ffffff' }}>Professional</span>{' '}
            <span style={{ color: '#387EF7' }}>Magazine &</span>
            <br />
            <span style={{ color: '#ffffff' }}>Periodicals</span>
            <br />
            <span style={{ color: '#ffffff' }}>Publishing</span>
          </h1>

          {/* Subheadline */}
          <p
            className="mb-10 max-w-xl"
            style={{
              fontFamily: 'Poppins, sans-serif',
              fontSize: '17px',
              color: 'rgba(255,255,255,0.85)',
              lineHeight: 1.7,
            }}
          >
            Caps N Corks II, LLC is a dedicated periodicals and magazine publishing company based in Jacksonville, Florida. We bring editorial vision, quality content, and professional publishing expertise to every project.
          </p>

          {/* CTAs */}
          <div className="flex flex-wrap gap-4">
            <button
              onClick={() => handleScrollTo('contact')}
              className="inline-flex items-center justify-center px-8 py-4 text-white font-medium uppercase tracking-widest transition-all duration-200 hover:opacity-90 hover:shadow-xl"
              style={{
                backgroundColor: '#0066CC',
                borderRadius: '7px',
                fontFamily: 'Poppins, sans-serif',
                fontSize: '13px',
                letterSpacing: '2px',
              }}
            >
              Request a Callback
            </button>
            <button
              onClick={() => handleScrollTo('contact')}
              className="inline-flex items-center justify-center px-8 py-4 font-medium uppercase tracking-widest transition-all duration-200 hover:bg-white hover:text-navy-DEFAULT"
              style={{
                backgroundColor: 'transparent',
                border: '2px solid rgba(255,255,255,0.7)',
                borderRadius: '7px',
                fontFamily: 'Poppins, sans-serif',
                fontSize: '13px',
                letterSpacing: '2px',
                color: '#ffffff',
              }}
            >
              Contact Us
            </button>
          </div>
        </div>
      </div>

      {/* Bottom wave */}
      <div className="absolute bottom-0 left-0 right-0 z-10">
        <svg viewBox="0 0 1440 60" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{ display: 'block', width: '100%', height: '60px' }}>
          <path d="M0 60L1440 60L1440 20C1200 60 960 0 720 20C480 40 240 0 0 20L0 60Z" fill="white" />
        </svg>
      </div>
    </section>
  );
};

export default HeroSection;
